import { Stack, Typography, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { parseToLocalDate } from '../../../../common/utils/parseToLocalDate';
import { CardStatus } from '../CardStatus/CardStatus';
import { UserSessionCardProps } from './types';
import { StyledGreenSpan } from '../../StyledGreenSpan/StyledGreenSpan';
import { StyledOrangeSpan } from '../../StyledOrangeSpan/StyledOrangeSpan';

export const UserSessionCard: React.FC<UserSessionCardProps> = ({ data }) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="column"
      sx={(theme: Theme) => ({
        borderRadius: '15px',
        padding: { xs: '12px' },
        border: `1px solid ${theme.palette.gray[200]}`,
        gap: { xs: '5px' },
      })}
    >
      {data.chargingStatus && (
        <>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body1" color="gray.50">
              {parseToLocalDate(data.updatedAt)}
            </Typography>
            <CardStatus
              chargingStatus={data.chargingStatus}
              text="userHistoryPage.card.status"
            />
          </Stack>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body1" color="common.white">
              {t('userHistoryPage.card.station')}: {data.idTag}
            </Typography>
            <Typography variant="body1" color="common.white">
              {t('userHistoryPage.card.connector')}: {data.connectorId}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body1" color="common.white">
              {t('userHistoryPage.card.meterStop')}:{' '}
              <StyledGreenSpan>
                {data.meterStop / 1000} {t('userHistoryPage.card.measurement')}
              </StyledGreenSpan>
            </Typography>
            <Typography variant="body1" color="common.white">
              {t('userHistoryPage.card.meterValue')}:{' '}
              <StyledGreenSpan>
                {(((data.meterValue ?? 0) - (data.meterStart ?? 0)) / 1000).toFixed(1)}{' '}
                {t('userHistoryPage.card.measurement')}
              </StyledGreenSpan>
            </Typography>
          </Stack>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body1" color="common.white">
              {t('userHistoryPage.card.sessionId')}: {data.sessionId}
            </Typography>
            {data.serviceFee !== undefined && (
              <Typography variant="body1" color="common.white">
                {t('userHistoryPage.card.serviceFee')}:{' '}
                <StyledGreenSpan>{data.serviceFee.toFixed(2)} ₴</StyledGreenSpan>
              </Typography>
            )}
          </Stack>
          {Number(data.idleMinutes) > 0 && (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="body1" color="common.white">
                {t('userHistoryPage.card.idleTime')}:{' '}
                <StyledOrangeSpan>
                  {data.idleMinutes} {t('userHistoryPage.card.minutes')}
                </StyledOrangeSpan>
              </Typography>
              {Number.isFinite(data.idleAmount) && (
                <Typography variant="body1" color="common.white">
                  {t('userHistoryPage.card.idleFee')}:{' '}
                  <StyledOrangeSpan>
                    {(data.idleAmount as number).toFixed(2)} ₴
                  </StyledOrangeSpan>
                </Typography>
              )}
            </Stack>
          )}
        </>
      )}
    </Stack>
  );
};
